import type { PlaneOrientation } from "../types";

/** Minimal shape of Cornerstone's `Enums.OrientationAxis` we depend on. */
export interface OrientationAxisEnum {
  ACQUISITION: unknown;
  AXIAL: unknown;
  CORONAL: unknown;
  SAGITTAL: unknown;
}

/**
 * Map a reslice target plane to a Cornerstone OrientationAxis value.
 * `undefined` → ACQUISITION (the series' native plane) — this is the default
 * for every non-reslice pane and MUST NOT change existing behavior.
 */
export function resolveOrientationAxis(
  plane: PlaneOrientation | undefined,
  axis: OrientationAxisEnum,
): unknown {
  switch (plane) {
    case "Coronal":
      return axis.CORONAL;
    case "Sagittal":
      return axis.SAGITTAL;
    case "Axial":
      return axis.AXIAL;
    default:
      return axis.ACQUISITION;
  }
}
